module.exports = __webpack_public_path__ + "resource/img/file.8dc1a135.svg";